<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">Conclusión Lesiones/Homicidios</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <div class="mt-2">
                                <span>Nombre del tercero:</span>
                                <p class="type-text-style">{{nombreTercero}}</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-2">
                                <span>Término de daños:</span>
                                <v-radio-group :class="classdisabled" v-model="datos.termino" style="margin: -1px; margin-left: 10px;">
                                    <v-radio label="Recuperamos del tercero" value="RT"></v-radio>
                                    <v-radio label="Pagamos al tercero" value="PT"></v-radio>
                                    <v-radio label="No se pudo recuperar" value="NR"></v-radio>
                                    <v-radio label="No se pudo pagar" value="NP"></v-radio>
                                </v-radio-group>
                            </div>



                            <div v-if="showRP">
                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span>Indemnización:</span>
                                    <p class="type-text-style">{{datos.indemnizacion}}</p>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <v-checkbox v-model="datos.pasemedico"
                                                label="Pase médico"
                                                style="margin: 0px"
                                                :class="classdisabledpase"
                                                hide-details></v-checkbox>
                                </div>
                                <br />

                            </div>

                            <div v-if="showOpciones">
                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span>Observaciones:</span>
                                    <v-textarea @input="uppercase('observaciones')"
                                                v-on:blur="datos.observaciones = datos.observaciones != null ? datos.observaciones.trim() : null"
                                                :counter="600"
                                                outlined
                                                :disabled="disabledIndem"
                                                :filled="disabledIndem"
                                                rows="3"
                                                v-model="datos.observaciones"></v-textarea>
                                </div>

                            </div>


                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn v-if="showLimpiaConclusion"
                                   dark
                                   class="ma-2"
                                   color="#FF4081"
                                   title="Limpiar"
                                   @click="limpiarConclusion()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Limpiar Conclusión</span>
                            </v-btn>
                            <v-btn dark
                                   class="ma-2"
                                   color="#B0BEC5"
                                   title="Regresar"
                                   @click="cancelar()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Regresar</span>
                            </v-btn>
                        </v-row>
                    </v-col>



                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>


<script>
    import Reporte from "@/services/ExpJur/ExpJur.service.js";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import moment from 'moment';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    export default {
        data() {
            return {
                showLimpiaConclusion: false,
                classdisabled:'disable-action',
                disabledIndem: true,
                classdisabledpase:'disable-action',
                showRP: false,
                showOpciones: false,
                disabledSave: false,
                validForm: true,
                nombreTercero: '',
                datos: {
                    termino: null,
                    indemnizacion: null,
                    pasemedico: null,
                    observaciones: null,
                },
                push: 0,
                displayInputs: {
                    d3id: 0
                },
            }
        },
        watch: {
            'datos.termino'(val) {
                this.showRP = false;
                this.showOpciones = false;

                if (val == 'RT') {
                    this.showRP = true;
                }
                if (val == 'PT') {
                    this.showRP = true;
                }
                if (val == 'NR') {
                    this.showOpciones = true;
                }
                if (val == 'NP') {
                    this.showOpciones = true;
                }

            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            async limpiarConclusion() {



                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: '¿Está seguro de limpiar la conclusión de lesiones/homicidios?',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.disabledSave = true;
                        this.$swal({
                            position: 'center',
                            title: 'Limpiando conclusión de lesiones/homicidios...',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                                this.$swal.showLoading();
                            }
                        });
                        await Reporte.limpiarConclusionLesiones(this).then(response => {
                            setTimeout(async () => {
                                this.$swal.close();

                                if (response) {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'success',
                                        title: 'Éxito',
                                        text: 'Se eliminó la conclusión de lesiones/homicidios...',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            this.cancelar();
                                        }
                                    })
                                    setTimeout(async () => {
                                        this.$swal.close();
                                        this.cancelar();
                                    }, 3000);

                                }
                                else {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'error',
                                        title: 'Error',
                                        text: 'Hubo un error al limpiar la conclusión de lesiones/homicidios, Favor de avisar a Desarrollo',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                    })
                                }




                            }, 1500);


                        });
                    }

                });


            },
            cancelar() {
                if (this.push == 0) {
                    this.push++;
                    this.$router.go(-1);
                }

            },
        },
        computed: {
            ...mapState(["domain", "informationPage", "permission"]),
        },
        async mounted() {
            let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
            if (clavetercero.d3id == undefined) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
            this.changeReporteMenuOption(clavetercero.urlname);
            this.displayInputs = {
                d3id: clavetercero.d3id
            };

            let datosTercero = await Reporte.obtenerDatosTercero(this, clavetercero.d3id);
            if ((datosTercero[0].d3lesiones || datosTercero[0].d3homicidio) && datosTercero[0].terminoLesHom == 'Ya') {
               
            }
            else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
            let validaConc = await MetodosGenerales.getReporteEstatus(this);

            //permiso para limpiar conclusion
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '112').then(response => {

                if (response.data.length > 0 && validaConc != 2) { //si tiene el permiso
                    this.showLimpiaConclusion = true;
                }
            });

            await Reporte.obtenerInfoDanios(this).then(response => {
                this.nombreTercero = response[0].d3nombre;

                this.datos.termino = response[0].d3formaterlesiones;
                this.datos.indemnizacion = response[0].d3montolesionesV;
                this.datos.pasemedico = response[0].d3PaseMedico;
                this.datos.observaciones = response[0].d3ObsLesiones;



            });


        }
    }
</script>

<style>
    .date-align-center .v-input input {
        text-align: center !important;
    }
</style>
<style scoped>
    .type-label-style {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        font-size: 12px;
    }

    .type-text-style {
        font-family: "Poppins", sans-serif;
        font-weight: 700;
        font-size: 1.3em;
    }
</style>